/**
 * Same media queries as pure css and as we used in css/settings/_media-queries.scss, but in pixel instead of em
 * Warning : these 2 files (JS + SCSS) must be synchronized !
 */
const breakpoints = {
    sm: 468,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1600
};

const mediaQueries = {
    smDown: `only screen and (max-width: ${breakpoints.sm - 1}px)`,
    smUp: `only screen and (min-width: ${breakpoints.sm}px)`,
    mdDown: `only screen and (max-width: ${breakpoints.md - 1}px)`,
    mdUp: `only screen and (min-width: ${breakpoints.md}px)`,
    lgDown: `only screen and (max-width: ${breakpoints.lg - 1}px)`,
    lgUp: `only screen and (min-width: ${breakpoints.lg}px)`,
    xlDown: `only screen and (max-width: ${breakpoints.xl - 1}px)`,
    xlUp: `only screen and (min-width: ${breakpoints.xl}px)`,
    mobileOnly: `only screen and (max-width: ${breakpoints.md - 1}px)`,
    tabletOnly: `only screen and (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg - 1}px)`,
    desktopOnly: `only screen and (min-width: ${breakpoints.lg}px)`,
    desktopOnlyHalfpageAdTreshold: `only screen and (min-width: ${breakpoints.xl}px)`,
    portrait: "(orientation: portrait)"
};

function matchQuery(query) {
    return window.matchMedia ? window.matchMedia(query).matches : false;
}

function isMobile() {
    return matchQuery(mediaQueries.mobileOnly);
}

function isTablet() {
    return matchQuery(mediaQueries.tabletOnly);
}

function isDesktop() {
    return matchQuery(mediaQueries.desktopOnly);
}

// at this treshold, the halfpage-3 ad moves from the side to the end of the article (while we are still in desktop),
// so we needed this special breakpoint to deal with collision
function isDesktopHalfpageAdTreshold() {
    return matchQuery(mediaQueries.desktopOnlyHalfpageAdTreshold);
}

function isPortrait() {
    return matchQuery(mediaQueries.portrait);
}

export default {
    breakpoints: breakpoints,
    mediaQueries: mediaQueries,

    matchQuery: matchQuery,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isDesktopHalfpageAdTreshold: isDesktopHalfpageAdTreshold,
    isPortrait: isPortrait,

    device() {
        if (isMobile()) {
            return "mobile";
        } else if (isTablet()) {
            return "tablet";
        } else if (isDesktop()) {
            return "desktop";
        } else if(isDesktopHalfpageAdTreshold()) {
            return "desktopHalfpageAdTreshold";
        } else {
            return "unknown";
        }
    },

    isLgUp() {
        return matchQuery(mediaQueries.lgUp);
    },

    isFullScreen() {
        return matchQuery('(display-mode: standalone)')
            || matchQuery('(display-mode: fullscreen)');
    }
}



// WEBPACK FOOTER //
// ./js/utils/MediaQueries.js